"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Vue } from "vue-property-decorator";
import { AddRulesController } from "../AddRulesPage.vue";
import i18n from "@/lang";
let AddRulesLeftPage = class extends Vue {
  constructor() {
    super(...arguments);
    this.chosed_account = 0;
    this.member_list = [
      {
        label: i18n.t("add_rules.form.member_list_4"),
        value: "all"
      },
      {
        label: i18n.t("add_rules.form.member_list_1"),
        value: "users"
      },
      {
        label: i18n.t("add_rules.form.member_list_2"),
        value: "department"
      }
      // {
      //   label: i18n.t("add_rules.form.member_list_3") as string,
      //   value: "role",
      // },
    ];
    this.shop_choices = [
      {
        label: i18n.t("add_rules.form.shop_choices_1"),
        value: "all"
      },
      {
        label: i18n.t("add_rules.form.shop_choices_2"),
        value: "shops"
      }
    ];
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  clearMembersSelected() {
    this._formController.rulesSelectorMembers = [];
  }
  // resetEnvironment(){
  //   this._formController.rulesEnvironmentShops = [];
  // }
  openChooseMembers() {
    this.$emit("openChooseMembers");
  }
  openChooseShops() {
    this.$emit("openChooseShops");
  }
};
__decorateClass([
  PropSync("formController", {
    type: Object,
    default: () => new AddRulesController()
  })
], AddRulesLeftPage.prototype, "_formController", 2);
AddRulesLeftPage = __decorateClass([
  Component({
    components: {}
  })
], AddRulesLeftPage);
export {
  AddRulesLeftPage as default
};
